// Deskwell — advertorial.js | vanilla JS, sin dependencias
(function () {
  var bar = document.getElementById('dw-sticky-bar');
  if (!bar) return;

  var appearAt = parseInt(bar.getAttribute('data-appear-at') || '30', 10);
  var ticking = false;

  function checkScroll() {
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrolled = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
    if (scrolled >= appearAt) {
      bar.classList.add('dw-visible');
    } else {
      bar.classList.remove('dw-visible');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(checkScroll);
      ticking = true;
    }
  }, { passive: true });

  checkScroll();
})();
